import { Conversation } from '../types/Conversation';

export const mergeConversationSnapshot = (
  conversation: Conversation,
  selectedConversation: Conversation,
): Conversation => {
  if (conversation.id !== selectedConversation.id) {
    return conversation;
  }

  return {
    ...conversation,
    ...selectedConversation,
    messages: selectedConversation.messages,
    participants: selectedConversation.participants,
    notes: selectedConversation.notes,
  };
};

export const mergeConversationSnapshotIntoList = (
  conversations: Conversation[],
  selectedConversation: Conversation | null,
): Conversation[] => {
  if (!selectedConversation) {
    return conversations;
  }

  return conversations.map(conversation => mergeConversationSnapshot(conversation, selectedConversation));
};

/** When the server omitted messages because the snapshot is unchanged, keep the local thread. */
export const applyCachedMessagesIfOmitted = (
  incoming: Conversation | null,
  cached: Conversation | null | undefined,
): Conversation | null => {
  if (!incoming) {
    return incoming;
  }

  if (incoming.messages.length > 0 || !cached?.messages.length || cached.id !== incoming.id) {
    return incoming;
  }

  const incomingUpdatedAt = Date.parse(incoming.updatedAt);
  const cachedUpdatedAt = Date.parse(cached.updatedAt);
  if (Number.isFinite(incomingUpdatedAt) && Number.isFinite(cachedUpdatedAt) && incomingUpdatedAt > cachedUpdatedAt) {
    return incoming;
  }

  return {
    ...incoming,
    messages: cached.messages,
    totalMessageCount: cached.totalMessageCount ?? incoming.totalMessageCount,
    hasMoreMessages: cached.hasMoreMessages ?? incoming.hasMoreMessages,
    containsWhatsAppMessages: cached.containsWhatsAppMessages || incoming.containsWhatsAppMessages,
    containsInstagramMessages: cached.containsInstagramMessages || incoming.containsInstagramMessages,
    containsInstagramComments: cached.containsInstagramComments || incoming.containsInstagramComments,
    containsMessengerComments: cached.containsMessengerComments || incoming.containsMessengerComments,
  };
};